window.theme = window.theme || {};


theme.AjaxCart = (function () {
  var selectors = {
    addToCartBtn: '[type="submit"]',
    addToCartForm: 'form[action="/cart/add"]',
    cartCount: '.site-header__cart-count',
    cartToggle: '.cart__toggle',
    cartDrawer: '#PopupCart',
    cartDrawerOpen: '.cart-drawer--open'
  };

  var settings = {
    // 'aboveForm' for top of add to cart form,
    // 'belowForm' for below the add to cart form,
    // 'nextButton' for next to add to cart button and
    // 'afterBody' for after the main body content (used for fixed notifications).
    feedbackPosition: 'afterBody'
  };

  var options = {
    requestBodyClass: 'cart-loading',
    moneyFormat: window.shop.moneyFormat,
    moneyWithCurrencyFormat: window.shop.moneyWithCurrencyFormat,
    weightUnit: 'kg', // g, kg, oz, lb
    weightPrecision: 0
  };

  var cache = {
    previousCartItems: [],
    updatedItems: []
  };

  function init() {
    $(document).on('click', '[data-add-to-cart], [data-cart-add], [data-cart-update], [data-cart-update-id], [data-cart-remove]', function () {
      var $this = $(this);
      var progressElementSelector = $this.data('progress-element');
      var $progressElement = progressElementSelector ? $(progressElementSelector) : $this;
    });

    initDrawer();

    // Override CartJS error handling
    // Uses extra code from https://github.com/discolabs/cartjs/issues/68#issuecomment-261418409
    CartJS.errorHandling = {
      cartError: function (error) {
        $('.cart-loader.loading').removeClass('loading');
        showFeedback('error', error.description);
      }
    }

    CartJS.init(window.shop.cart, options);

    /*$('.cart-drawer__submit').click(function(){
      $(document.body).addClass('checkout-activated');
    });*/

    $(document).on('cartfox:requestStarted', function (event) {
      cache.previousCartItems = cart.cart.items;
      if ('NProgress' in window) {
        NProgress.start();
      }
      $('#PopupCart .popup-content').addClass('is-loading');
      $('#PopupCart #loading-icon').show();
    })
    $(document).on('cartfox:itemAdded', function (event) {
      //console.log(event);
      //cache.updatedItems = _.differenceWith(cache.previousCartItems, cart.items, _.isEqual);

      shop.cart = cart.cart;
      if (typeof Upsell !== "undefined") {
        //Upsell.refresh(cache.previousCartItems, shop.cart.items);
        //Upsell.reRender(cart);
      }
      $('#PopupCart .popup-content').removeClass('is-loading');
      $('#PopupCart #loading-icon').hide();
    })
    $(document).on('cartfox:requestComplete', function (event, cart1) {
      //console.log(cart1);
      $('.cart-loader.loading').removeClass('loading');
      //cache.updatedItems = _.differenceWith(cache.previousCartItems, cart.items, _.isEqual);

      shop.cart = cart.cart;
      if (typeof Upsell !== "undefined") {
        //Upsell.refresh(cache.previousCartItems, shop.cart.items);
        //Upsell.reRender(cart);
      }
      //$('#PopupCart .popup-content').removeClass('is-loading');
      //$('#PopupCart #loading-icon').hide();
    });
  }

  function initDrawer() {
    cartDrawerOpen();
  }

  function cartDrawerOpen() {
    // $(selectors.cartToggle).addClass(settings.cartDrawerOpen);
    if ("Upsell" in window) {
      Upsell.reRender();
    }
  }

  function cartDrawerClose() {
    // $(selectors.cartToggle).removeClass(settings.cartDrawerOpen);
  }

  return {
    init: init
  };
})();

theme.AjaxCart.init();